import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SectionRowComponent } from '@shared-ui-lib/section-row/section-row.component'

@NgModule({
    declarations: [SectionRowComponent],
    exports: [SectionRowComponent],
    imports: [CommonModule],
})
export class SectionRowModule {}
